import auth from "../../middlewares/auth";

export const portForwardingRoutes = [
    {
        path: '/port-forwardings',
        component: () => import(/* webpackChunkName: "services" */ '../../views/services/port_forwardings/PortForwardingIndex.vue'),
        name: 'port_forwardings',
        meta: {
            middleware: [
                auth
            ]
        }
    }
]